import { deleteAllCookies } from "@/helpers/cookies_helper";

export default {
  name: "HeaderComponent",
  data: () => ({
    isLoggedIn: false,
    base_url: process.env.VUE_APP_BASE_URL,
    subCategories: [],
    keyword: "",
    loading: {
      subCategories: true,
    },
  }),
  mounted() {
    this.checkAuth();
    this.getCategories();
  },

  computed: {
    userRole: function () {
      return this.$store.state.user.role;
    },
    userState: function () {
      return this.$store.state.user;
    },
    profile_picture() {
      if (!this.$store.state.user.mh_customer?.image_profile_url) {
        return "https://images.unsplash.com/photo-1661862230212-9852e77ee5a4?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=987&q=80";
      }

      return this.$store.state.user.mh_customer?.image_profile_url;
    },

    tier() {
      if (this.$store.state.user.mh_customer.mh_tier) {
        if (this.$store.state.user.mh_customer?.mh_tier.length <= 0)
          return false;

        return this.$store.state.user.mh_customer?.mh_tier[0].name;
      }
    },
  },
  methods: {
    getCategories: function () {
      this.$axios.get("/subcategory-header").then((res) => {
        if (res) {
          this.subCategories = res.data.subcategories;
          this.loading.subCategories = false;
        }
      });
    },
    checkAuth: function () {
      if (this.$store.state.user && localStorage.getItem("token")) {
        this.isLoggedIn = true;
      } else {
        this.isLoggedIn = false;
      }
    },
    goToCart: function () {
      this.$router.push("/cart");
    },
    searchProduct: function () {
      this.$router.push("/product?keyword=" + this.keyword);
      this.keyword = "";
    },
    activeclass: function () {
      var path = window.location.href;

      this.Class(".mobile-nav a").each(function () {
        if (this.href === path) {
          this.addClass("active");
        } else {
          this.removeClass("active");
        }
      });
    },

    logout() {
      this.$swal({
        title: "Anda Akan Keluar Dari Aplikasi",
        text: "Lanjut?",
        icon: "warning",
        showCancelButton: true,
        buttons: true,
        dangerMode: true,
      }).then((value) => {
        if (value.isConfirmed) {
          this.$axios.post("/logout");
          this.$store.commit("updateUser", null);
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          delete this.$axios.defaults.headers.Authorization;
          deleteAllCookies();
          this.checkAuth();

          this.$router.push("/");
        }
        return;
      });
    },
  },
};
